export const SET_DFO_CORE = 'SET_DFO_CORE';
export const REMOVE_DFO_CORE = 'REMOVE_DFO_CORE';
export const ADD_TRANSACTION = 'ADD_TRANSACTION';
export const REMOVE_TRANSACTION = 'REMOVE_TRANSACTION';
export const CLEAR_TRANSACTIONS = 'CLEAR_TRANSACTIONS';
export const SET_MAGIC_VISUAL_MODE = 'SET_MAGIC_VISUAL_MODE';
export const TOGGLE_SIDEMENU = 'TOGGLE_SIDEMENU';